import { render, staticRenderFns } from "./PriceApprove.vue?vue&type=template&id=09db4de7"
import script from "./PriceApprove.vue?vue&type=script&lang=js"
export * from "./PriceApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports